export default {"src":"/_next/static/media/pet-owner.9aae9e0e.svg","height":79,"width":78,"blurWidth":0,"blurHeight":0};